$(function () {
  const msSelectEl = $('.MS');
  const serviceControllerEl = $('.serviceController');
  const serviceControllerNotBossEl = $('.serviceControllerNotBoss');
  let infiniteScroll = {
    loading: false,
    endLoading: false,
    currentPage: 1
  }

  function updateQueryString(key, value) {
    if (history.pushState) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, value);
      let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
      window.history.pushState({path: newUrl}, '', newUrl);
    }
  }

  function getParams() {
    const params = {};
    params.page = infiniteScroll.currentPage;

    if (serviceControllerEl.length) {
      params.serviceController = serviceControllerEl.val();
    }

    if (serviceControllerNotBossEl.length) {
      params.serviceController = serviceControllerNotBossEl.val();
    }

    if (params.serviceController === '全品目') {
      params.serviceController = 'all';
    }

    updateQueryString('serviceController', params.serviceController);

    if (msSelectEl.length) {
      params.ceCode = msSelectEl.val();
      updateQueryString('ceCode', params.ceCode)
    }

    return params;
  }

  function fetchData() {
    infiniteScroll.loading = true;
    const params = getParams();
    $.ajax({
      url: '/prod_ins_emps/get_emp_details_boss',
      method: 'get',
      data: params,
      success: function(res) {
        let html = '';
        $.each(res.data, (index, item) => {
          const classNames = ['ins-list-item', 'salesDetails'];
          if (item.unread_sale_details_count) classNames.push('is-online')
          html += `<li class="${classNames.join(' ')}" value="${item.product_institution.service_control_id}" id="${item.product_institution.institution_code}">`;
          html += `<div>`;
          html += `<div class="title">${item.product_institution.institution.ins_short_name_kanji}</div>`;
          html += `<div class="title">${item.x_maker_brand_name}</div>`;
          html += `</div>`;
          html += item.sale_details_count ? `<div class="balloon">${item.sale_details_count}</div>` : '';
          html += `</li>`;
        });
        $(".listOfData ul").append(html);
        if (res.current_page == res.last_page) {
          infiniteScroll.endLoading = true;
        }
      },
      complete: function () {
        infiniteScroll.loading = false;
        infiniteScroll.currentPage++;
      }
    })
  };

  function fetchDataForNotBoss() {
    infiniteScroll.loading = true;
    const params = getParams();
    $.ajax({
      url: '/prod_ins_emps/get_emp_details_not_boss',
      method: 'get',
      data: params,
      success: function (res) {
        let html = '';
        $.each(res.data, (index, item) => {
          const classNames = ['ins-list-item', 'salesDetails'];
          if (item.unread_sale_details_count) classNames.push('is-online')
          html += `<li class="${classNames.join(' ')}" value="${item.product_institution.service_control_id}" id="${item.product_institution.institution_code}">`;
          html += `<div>`;
          html += `<div class="title">${item.product_institution.institution.ins_short_name_kanji}</div>`;
          html += `<div class="title">${item.x_maker_brand_name}</div>`;
          html += `</div>`;
          html += item.sale_details_count ? `<div class="balloon">${item.sale_details_count}</div>` : '';
          html += `</li>`;
        });
        $(".listOfDataNotBoss ul").append(html);
        if (res.current_page == res.last_page) {
          infiniteScroll.endLoading = true;
        }
      },
      complete: function () {
        infiniteScroll.loading = false;
        infiniteScroll.currentPage++;
      }
    })
  };

  $('.ins-list').on('click', '.salesDetails', function () {
    var serviceController = $(this).attr("value");
    var institution = $(this).attr("id");
    var url = '/sales_details?service_control_id=' + Number(serviceController) + '&institution_code=' + Number(institution);
    window.location.href = url
  });

  if (serviceControllerEl.length) {
    fetchData();
    serviceControllerEl.change(function () {
      fetchData();
    });
  }

  if (serviceControllerNotBossEl.length) {
    fetchDataForNotBoss();
    serviceControllerNotBossEl.change(function () {
      $(".listOfDataNotBoss ul").html("");
      infiniteScroll.currentPage = 1;
      infiniteScroll.endLoading = false;
      fetchDataForNotBoss();
    });
  }

  if (msSelectEl.length) {
    msSelectEl.change(function () {
      infiniteScroll.currentPage = 1;
      infiniteScroll.endLoading = false;
      fetchData();
    });
  }

  // Infinite scroll pagination
  $('.listOfDataNotBoss').scroll(function() {
    if (infiniteScroll.loading) {
      return;
    }

    if (infiniteScroll.endLoading) {
      return $('.listOfDataNotBoss .ajax-load').hide();
    }

    const scrollHeight = $('.listOfDataNotBoss').prop('scrollHeight')
    const scrollTop = $('.listOfDataNotBoss').scrollTop()
    const offsetHeight = $('.listOfDataNotBoss').prop('offsetHeight')
    const offset = scrollHeight - scrollTop - offsetHeight

    if (offset < 50) {
      $('.listOfDataNotBoss .ajax-load').show();
      fetchDataForNotBoss()
    }
  });

  $('.listOfData').scroll(function() {
    if (infiniteScroll.loading) {
      return;
    }

    if (infiniteScroll.endLoading) {
      return $('.listOfData .ajax-load').hide();
    }

    const scrollHeight = $('.listOfData').prop('scrollHeight');
    const scrollTop = $('.listOfData').scrollTop();
    const offsetHeight = $('.listOfData').prop('offsetHeight');
    const offset = scrollHeight - scrollTop - offsetHeight;

    if (offset < 50) {
      $('.listOfData .ajax-load').show();
      fetchData();
    }
  });
});